module.exports = __webpack_public_path__ + "img/help-tooltip-info-question.fbb76ff4.svg";